<ng-container [ngSwitch]="status">
  <wchfs-icon *ngSwitchCase="activeOrInactive.ACTIVE" svgIcon="pso:success_m" size="24"></wchfs-icon>
  <wchfs-icon *ngSwitchCase="activeOrInactive.INACTIVE" svgIcon="pso:not_allowed_m" size="24"></wchfs-icon>
</ng-container>
